import PropTypes from 'prop-types';
import { Button, Card, Layout, ModalV2 as Modal } from '@utilities';

const ModalDeleteQuotaGroup = ({ group, onClose, onSubmit }) => {
  const actionButtons = [
    <Button key="modal-cancel-button" onClick={onClose} text="Cancel" variant="secondary" />,
    <Button key="modal-confirm-button" onClick={onSubmit} text="Save" />,
  ];

  return (
    <Modal
      buttons={actionButtons}
      id="modal-delete-quota-group"
      isActive
      onClose={onClose}
      title="Delete Quota Group"
    >
      <div>
        <p>
          Are you sure you want to remove the quota group <strong>&quot;{group.name}&quot;</strong>?
        </p>
        {group.affectedQuestions.length > 0 && (
          <>
            <p>The following questions will be affected:</p>
            <br />
            <Layout.Flex.Column>
              {group.affectedQuestions.map(({ id, text }) => (
                <Card key={id}>
                  <p>{text}</p>
                </Card>
              ))}
            </Layout.Flex.Column>
          </>
        )}
        {group.affectedQuestionGroups?.length > 0 && (
          <>
            <p>The following question groups will be affected:</p>
            <br />
            <Layout.Flex.Column>
              {group.affectedQuestionGroups.map(({ id, name }) => (
                <Card key={id}>
                  <p>{name}</p>
                </Card>
              ))}
            </Layout.Flex.Column>
          </>
        )}
      </div>
    </Modal>
  );
};

ModalDeleteQuotaGroup.propTypes = {
  group: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ModalDeleteQuotaGroup;
